import React from 'react';
import MyRouter from './router';

function App() {
  return (
    <div className="app">
      <MyRouter />
    </div>
  );
}

export default App;